/**
 * Globo material_outlined contact form → flat legacy JWC style.
 * Faux placeholder overlays (Globo hides native ::placeholder when unfocused).
 */
(function () {
  const WRAPPER = '.custom-contact-form-wrapper';
  const MAX_RUNS = 12;

  const PLACEHOLDERS_BY_NAME = {
    name: 'placeholderName',
    phone: 'placeholderPhone',
    email: 'placeholderEmail',
    text: 'placeholderSubject',
    textarea: 'placeholderMessage',
  };

  const DEFAULT_PH = {
    name: 'Your Name*',
    phone: 'Your Number*',
    email: 'Email*',
    text: 'Subject*',
    textarea: 'How can we help you?',
  };

  let runCount = 0;
  let scheduled = null;
  let observer = null;

  function placeholderFor(input, wrapper) {
    const name = (input.getAttribute('name') || '').toLowerCase();
    const dataKey = PLACEHOLDERS_BY_NAME[name];
    const fromData = dataKey && wrapper.dataset[dataKey];
    if (fromData) return fromData;
    if (DEFAULT_PH[name]) return DEFAULT_PH[name];
    return '';
  }

  function flatInput(el) {
    if (el.dataset.jwcFlat) return;
    el.dataset.jwcFlat = '1';
    el.style.setProperty('border-radius', '0', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
    el.style.setProperty('background', '#fff', 'important');
    el.style.setProperty('font-size', '14px', 'important');
    el.style.setProperty('font-weight', '300', 'important');
    el.style.setProperty('color', '#3D2424', 'important');
    el.style.setProperty('outline', 'none', 'important');
  }

  function fauxPhoneLeft(input) {
    const iti = input.closest('.iti');
    const flag = iti && iti.querySelector('.iti__flag-container');
    if (!flag) return 88;
    return Math.ceil(flag.offsetLeft + flag.offsetWidth + 8);
  }

  function applyPhoneLayout(input, faux) {
    const iti = input.closest('.iti');
    if (!iti) return;

    iti.style.setProperty('display', 'flex', 'important');
    iti.style.setProperty('flex-direction', 'row', 'important');
    iti.style.setProperty('align-items', 'stretch', 'important');

    const flag = iti.querySelector('.iti__flag-container');
    if (flag) flag.style.setProperty('position', 'relative', 'important');

    input.style.setProperty('flex', '1 1 auto', 'important');
    input.style.setProperty('width', 'auto', 'important');
    input.style.setProperty('min-width', '0', 'important');
    input.style.setProperty('border', 'none', 'important');
    input.style.setProperty('box-shadow', 'none', 'important');
    input.style.setProperty('background', 'transparent', 'important');
    input.style.setProperty('padding', '5px 14px 5px 10px', 'important');
    input.style.removeProperty('padding-left');

    if (faux) faux.style.left = fauxPhoneLeft(input) + 'px';
  }

  function syncPhoneLayout(iti, input, faux) {
    if (!input.dataset.jwcPhoneSynced) {
      input.dataset.jwcPhoneSynced = '1';
      input.removeAttribute('placeholder');
    }

    const fixLayout = () => applyPhoneLayout(input, faux);

    const fixAfterGlobo = () => {
      fixLayout();
      requestAnimationFrame(fixLayout);
      window.setTimeout(fixLayout, 0);
      window.setTimeout(fixLayout, 50);
    };

    fixLayout();

    if (!input.dataset.jwcPhoneListeners) {
      input.dataset.jwcPhoneListeners = '1';
      /* Globo handleChangePhone resets padding on every keystroke — fix after it runs */
      input.addEventListener('input', fixAfterGlobo);
      input.addEventListener('keyup', fixAfterGlobo);
      input.addEventListener('focus', fixLayout);
      input.addEventListener('blur', fixAfterGlobo);
      iti.addEventListener('countrychange', fixAfterGlobo);
      window.addEventListener('resize', fixLayout);

      let guard = false;
      const styleObserver = new MutationObserver(() => {
        if (guard) return;
        const pad = parseFloat(window.getComputedStyle(input).paddingLeft) || 0;
        const left = fauxPhoneLeft(input);
        if (pad > left + 20 || pad < 8) {
          guard = true;
          applyPhoneLayout(input, faux);
          guard = false;
        }
      });
      styleObserver.observe(input, { attributes: true, attributeFilter: ['style'] });

      [100, 400, 1200].forEach((ms) => window.setTimeout(fixLayout, ms));
    }
  }

  function updateFauxVisibility(input, faux) {
    const hide = Boolean(input.value && input.value.trim()) || document.activeElement === input;
    const hidden = faux.classList.contains('is-hidden');
    if (hide !== hidden) faux.classList.toggle('is-hidden', hide);
  }

  function attachFauxPlaceholder(input, wrapper) {
    if (input.dataset.jwcFaux) {
      const iti = input.closest('.iti');
      const faux = (iti || input.closest('.globo-form-input'))?.querySelector('.jwc-faux-placeholder');
      if (iti && faux) applyPhoneLayout(input, faux);
      if (faux) updateFauxVisibility(input, faux);
      return;
    }

    const ph = placeholderFor(input, wrapper);
    if (!ph) return;

    input.dataset.jwcFaux = '1';
    input.removeAttribute('placeholder');

    const container = input.closest('.globo-form-input');
    if (!container) return;

    const iti = input.closest('.iti');
    const host = iti || container;

    const faux = document.createElement('span');
    faux.className = 'jwc-faux-placeholder';
    if (input.tagName === 'TEXTAREA') faux.classList.add('jwc-faux-placeholder--textarea');
    faux.setAttribute('aria-hidden', 'true');
    faux.textContent = ph;
    host.appendChild(faux);

    const refresh = () => updateFauxVisibility(input, faux);
    input.addEventListener('focus', refresh);
    input.addEventListener('blur', refresh);
    input.addEventListener('input', refresh);

    if (iti) syncPhoneLayout(iti, input, faux);
    refresh();
  }

  function flatPhone(formRoot) {
    if (formRoot.dataset.jwcPhoneBox) return;
    const iti = formRoot.querySelector('.iti');
    if (!iti) return;
    formRoot.dataset.jwcPhoneBox = '1';
    iti.style.setProperty('display', 'flex', 'important');
    iti.style.setProperty('width', '100%', 'important');
    iti.style.setProperty('border', '1px solid #D9D9D9', 'important');
    iti.style.setProperty('border-radius', '0', 'important');
    iti.style.setProperty('background', '#fff', 'important');
    iti.style.setProperty('box-sizing', 'border-box', 'important');
  }

  function flatSubmit(formRoot) {
    formRoot.querySelectorAll('button.submit, button.material_outlined-button.submit').forEach((btn) => {
      if (btn.dataset.jwcLabel) return;
      btn.dataset.jwcLabel = '1';
      btn.style.setProperty('border-radius', '0', 'important');
      btn.style.setProperty('background', '#3d2424', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('box-shadow', 'none', 'important');
      btn.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('text-transform', 'uppercase', 'important');
      btn.style.setProperty('font-weight', '600', 'important');
      btn.style.setProperty('padding', '16px', 'important');
      const spinner = btn.querySelector('.spinner');
      if (spinner) spinner.style.setProperty('display', 'none', 'important');
      btn.textContent = 'SEND';
    });
  }

  function formReady(formRoot) {
    const inputs = formRoot.querySelectorAll('input.material_outlined-input, textarea.material_outlined-input');
    return inputs.length >= 4;
  }

  function stopWatching() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (scheduled) {
      clearTimeout(scheduled);
      scheduled = null;
    }
  }

  function apply(wrapper) {
    if (wrapper.dataset.jwcGloboReady === '1') return;
    if (runCount >= MAX_RUNS) {
      stopWatching();
      return;
    }
    runCount += 1;

    const formRoot = wrapper.querySelector('.globo-formbuilder');
    if (!formRoot || !formReady(formRoot)) return;

    formRoot.querySelectorAll('.panels, .wizard__content, .panel').forEach((el) => {
      if (!el.dataset.jwcHeight) {
        el.dataset.jwcHeight = '1';
        el.style.setProperty('height', 'auto', 'important');
      }
    });

    formRoot.querySelectorAll('input.material_outlined-input, textarea.material_outlined-input').forEach((input) => {
      const inIti = input.closest('.iti');
      flatInput(input);
      if (!inIti) {
        input.style.setProperty('border', '1px solid #D9D9D9', 'important');
        input.style.setProperty('width', '100%', 'important');
        input.style.setProperty('box-sizing', 'border-box', 'important');
        input.style.setProperty('padding', '5px 14px', 'important');
      }
      attachFauxPlaceholder(input, wrapper);
    });

    flatPhone(formRoot);
    flatSubmit(formRoot);

    wrapper.dataset.jwcGloboReady = '1';
    stopWatching();
  }

  function scheduleApply(wrapper) {
    if (wrapper.dataset.jwcGloboReady === '1') return;
    if (scheduled) clearTimeout(scheduled);
    scheduled = window.setTimeout(() => {
      scheduled = null;
      apply(wrapper);
    }, 150);
  }

  function init() {
    const wrapper = document.querySelector(WRAPPER);
    if (!wrapper) return;

    apply(wrapper);
    if (wrapper.dataset.jwcGloboReady === '1') return;

    observer = new MutationObserver(() => scheduleApply(wrapper));
    observer.observe(wrapper, { childList: true, subtree: true });

    let polls = 0;
    const poll = window.setInterval(() => {
      polls += 1;
      apply(wrapper);
      if (wrapper.dataset.jwcGloboReady === '1' || polls >= 20) {
        window.clearInterval(poll);
        stopWatching();
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
